import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
  Typography,
  Box,
} from '@mui/material';
import { formatCurrency } from '../utils/lib';
import { useTranslation } from 'react-i18next';

const PaymentDialog = ({
  addPaymentDialog,
  paymentTypes,
  handleAddPaymentClose,
  handleAddPaymentConfirm,
  handleAmountChange,
  handlePaymentTypeChange
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={addPaymentDialog.open}
      onClose={handleAddPaymentClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{t('view.makePayment')}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
          <Typography>
            {`${t('view.paymentOwner')} ${addPaymentDialog.owner?.name || ''}`}
          </Typography>
          <Typography>
            {`${t('view.currentDebt')} ${addPaymentDialog.owner?.balance ? formatCurrency(addPaymentDialog.owner.balance) : formatCurrency(0)}`}
          </Typography>
          <Autocomplete
            fullWidth
            options={paymentTypes}
            getOptionLabel={(option) => option?.name || ""}
            value={addPaymentDialog.paymentType}
            onChange={handlePaymentTypeChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t('common.paymentMethod')}
                required
              />
            )}
          />
          <TextField
            label={t('view.paymentAmount')}
            type="number"
            value={addPaymentDialog.amount}
            onChange={handleAmountChange}
            fullWidth
            InputProps={{
              startAdornment: <Typography sx={{ mr: 1 }}>$</Typography>
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddPaymentClose}>{t('common.cancel')}</Button>
        <Button 
          onClick={handleAddPaymentConfirm} 
          variant="contained" 
          color="primary"
          disabled={
            addPaymentDialog.isLoading ||
            !addPaymentDialog.amount || 
            parseFloat(addPaymentDialog.amount) <= 0 || 
            !addPaymentDialog.paymentType
          }
        >
          {t('view.processPayment')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentDialog; 